import { DiplomeEnum } from '@graphql/generated';
import { Diplome } from '@lib/models/demande-affiliation/types/diplome.type';
export class DiplomeMapper {
  public static fromGraphQl(input?: DiplomeEnum): Diplome | undefined {
    const mapping: Record<DiplomeEnum, Diplome> = {
      SANS_DIPLOME: 'sans_diplome',
      BEP_CAP: 'bep_cap',
      BAC: 'bac',
      BAC_PLUS_2: 'bac+2',
      BAC_PLUS_3: 'bac+3',
      BAC_PLUS_4: 'bac+4',
      BAC_PLUS_5: 'bac+5',
      AUTRE: 'autre',
    };
    return input ? mapping[input] : undefined;
  }
}
